module.exports = __webpack_public_path__ + "static/media/instructor-performance-feedback-thats-all.4717f49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-performance-feedback-thats-all.png
// module id = 2656
// module chunks = 0